import { useEffect } from 'react';

const useScrollTracking = () => {
  useEffect(() => {
    const scrollDepths = [25, 50, 75, 100];
    const firedDepths: { [key: number]: boolean } = {};

    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      const scrollPercent = (scrollPosition / documentHeight) * 100;

      scrollDepths.forEach((depth) => {
        if (scrollPercent >= depth - 1 && !firedDepths[depth]) {
          firedDepths[depth] = true;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'custom_scroll',
            event_category: 'Scroll Tracking',
            event_action: `${depth}%`,
            depth: `${depth}%`,
          });
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
};

export default useScrollTracking;
